module.exports = __webpack_public_path__ + "assets/placeholder-selfie.svg";